import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { TrustStrip } from './TrustStrip';
import { CountdownTimer } from './CountdownTimer';
import { oferta, incluyeOferta } from '../data/oferta';
interface OfferBoxProps {
  className?: string;
}
export function OfferBox({
  className = ''
}: OfferBoxProps) {
  return <div className={`mx-auto max-w-2xl rounded-2xl border-2 border-gold bg-ink-800 p-5 text-left shadow-lift sm:rounded-3xl sm:p-8 ${className}`} data-id="element-99" data-mp="1oox9iva8ukm1">
      <span className="inline-flex w-fit rounded-full bg-gold px-3 py-1 font-sans text-[10px] font-bold uppercase tracking-[0.12em] text-ink-900 sm:px-4 sm:py-1.5 sm:text-xs sm:tracking-[0.14em]" data-id="element-100" data-mp="2hcjoezox9bo7">
        {oferta.etiqueta}
      </span>

      <h3 className="mt-4 font-display text-xl font-extrabold leading-tight text-cream sm:mt-5 sm:text-3xl" data-id="element-101" data-mp="27lyissatz6vs">
        {oferta.nombre}
      </h3>
      <p className="mt-1 font-sans text-sm text-cream-200 sm:text-base" data-id="element-102" data-mp="2varecnnjjcpv">
        {oferta.detalle}
      </p>

      <div className="mt-4 flex flex-wrap items-baseline gap-x-3 gap-y-1 sm:mt-6" data-id="element-103" data-mp="35gdym2kaa7n3">
        <span className="font-display text-4xl font-extrabold leading-none text-cream sm:text-6xl" data-id="element-104" data-mp="35eb5varqy0eo">
          {oferta.precio}
        </span>
        <span className="font-sans text-sm text-cream-300 line-through sm:text-base" data-id="element-105" data-mp="3f6h06r5h0tx1">
          Valor real: {oferta.valorReal}
        </span>
      </div>

      <CountdownTimer className="mt-4 sm:mt-5" data-id="element-106" data-mp="3ade4acd818do" />

      <ul className="mt-4 grid grid-cols-2 gap-x-3 gap-y-1.5 sm:mt-5" data-id="element-107" data-mp="3o642df60y3r5">
        {incluyeOferta.map(item => <li key={item} className="flex items-start gap-1.5 font-sans text-xs text-cream-200 sm:text-sm" data-id="element-108" data-mp="3k4ihp7n90l6e">
            <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold sm:h-4 sm:w-4" aria-hidden="true" data-id="element-109" data-mp="1xb6cybwuy2j" />
            {item}
          </li>)}
      </ul>

      <a href={oferta.checkoutUrl} className="group mt-5 flex w-full items-center justify-center gap-2.5 rounded-xl bg-gold px-4 py-3.5 font-sans text-sm font-bold uppercase tracking-wide text-ink-900 shadow-lift transition-[transform,background-color] duration-200 ease-out hover:-translate-y-0.5 hover:bg-gold-400 active:translate-y-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold sm:mt-7 sm:py-5 sm:text-lg" data-id="element-110" data-mp="23sv9h1jyqk9e">
        <ZapIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:scale-110 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-111" data-mp="gm7o4aqd1bo9" />
        <span className="text-center leading-tight" data-id="element-112" data-mp="ql6v7ovh8z95">
          Sí, quiero mi Mega Pack · {oferta.precio}
        </span>
      </a>

      <TrustStrip tone="dark" className="mt-3.5 sm:mt-5" data-id="element-113" data-mp="vfuftcnd19ig" />
    </div>;
}